interface FaqTemplate<T extends Record<string, string | number>> {
  question: (city: string) => string;
  answer: (city: string, data: T) => string;
}

export const currentForecastTemplate: FaqTemplate<{
  currentTemperature: number;
  windTemperature: number;
  description: string;
  windDirection: string;
  windSpeed: number;
}> = {
  question: (city: string) => `Какая сейчас погода ${city}?`,
  answer: (city: string, data) =>
    `Сейчас ${city} температура воздуха ${data.currentTemperature}°, при ветре ощущается как ${data.windTemperature}°. ${data.description}. Ветер ${data.windDirection}, ${data.windSpeed} м/с.`,
};

export const todayTemperatureTemplate: FaqTemplate<{
  currentTemperature: number;
  windTemperature: number;
  morningTemperature: number;
  dayTemperature: number;
  eveningTemperature: number;
  nightTemperature: number;
}> = {
  question: (city: string) => `Какая сегодня температура воздуха ${city}?`,
  answer: (city: string, data) =>
    `Сейчас ${city} температура воздуха ${data.currentTemperature}°, при ветре ощущается как ${data.windTemperature}°. Температура утром ${data.morningTemperature}°, днем ${data.dayTemperature}°, вечером ${data.eveningTemperature}°, ночью ${data.nightTemperature}°.`,
};

export const precipitationForecastTemplate: FaqTemplate<{
  currentDescription: string;
  expectedDescription: string;
  humidity: number;
}> = {
  question: (city: string) => `Есть ли осадки ${city} сейчас?`,
  answer: (city: string, data) =>
    `Сейчас ${city} ${data.currentDescription}. Ожидается ${data.expectedDescription}. Влажность ${data.humidity}%.`,
};

export const tomorrowForecastTemplate: FaqTemplate<{
  minTemperature: number;
  maxTemperature: number;
  description: string;
}> = {
  question: (city: string) => `Какой прогноз погоды на завтра ${city}?`,
  answer: (city: string, data) =>
    `Завтра ${city} ожидается от ${data.minTemperature}° до ${data.maxTemperature}°. ${data.description}.`,
};
